<app-table
  [config]="tableConfig"
  [data]="tableData"
>
</app-table>
